import { call, fork, put, select, takeLatest } from 'redux-saga/effects'
import { logoutUser } from '../actions/user/user.actions'
import * as actions from '../actions/meter.actions'
import * as api from '../api/meter.api'

function* getMeters() {
  try {
    const state = yield select()

    const meters = yield call(
      api.getUserMeters,
      state.user.userData.data.userId
    )
    yield put(actions.getMetersSuccess(meters.data))
  } catch (err) {
    if (err.response.status === 401) yield put(logoutUser())
    yield put(
      actions.meterError({
        error: 'An error occurred when trying to get meters',
      })
    )
  }
}

function* watchGetMetersRequest() {
  yield takeLatest(actions.Types.GET_METERS, getMeters)
}

function* newMeterReading({ payload }) {
  try {
    const state = yield select()
    yield call(api.newMeterReading, {
      userId: state.user.userData.data.userId,
      meterSiteCode: payload.meterSiteCode,
      meterCode: payload.meterCode,
      readingDate: payload.readingDate,
      value: parseFloat(payload.value),
    })

    yield put(actions.newMeterReadingSuccess())
  } catch (err) {
    if (err.response.status === 401) yield put(logoutUser())
    yield put(actions.meterError(err.response.data))
  }
}

function* watchNewMeterReading() {
  yield takeLatest(actions.Types.NEW_METER_READING, newMeterReading)
}

function* newCombinedMeterReading({ payload }) {
  try {
    const state = yield select()
    yield call(api.newCombinedMeterReading, {
      userId: state.user.userData.data.userId,
      meterSiteCode: payload.meterSiteCode,
      meterCode1: payload.meterCode1,
      readingDate1: payload.readingDate1,
      value1: parseFloat(payload.value1),
      meterCode2: payload.meterCode2,
      readingDate2: payload.readingDate2,
      value2: parseFloat(payload.value2),
    })

    yield put(actions.newMeterReadingSuccess())
  } catch (err) {
    if (err.response.status === 401) yield put(logoutUser())
    yield put(actions.meterError(err.response.data))
  }
}

function* watchNewCombinedMeterReading() {
  yield takeLatest(
    actions.Types.NEW_COMBINED_METER_READING,
    newCombinedMeterReading
  )
}

function* enableManualReading({ payload }) {
  try {
    const state = yield select()

    yield call(api.enableMeterManualReading, {
      userId: state.user.userData.data.userId,
      meterId: payload.meterId,
    })
    yield put(actions.getMeters())
  } catch (err) {
    if (err.response.status === 401) yield put(logoutUser())
    yield put(actions.meterError(err.response.data))
  }
}

function* watchEnableManualReading() {
  yield takeLatest(
    actions.Types.ENABLE_METER_MANUAL_READING,
    enableManualReading
  )
}

function* meterReadingsByDay({ payload }) {
  try {
    const state = yield select()

    const metersReadings = yield call(api.meterReadingsByDay, {
      userId: state.user.userData.data.userId,
      meterSiteCode: payload.meterSiteCode,
      meterCode: payload.meterCode,
      dateFrom: payload.dateFrom,
      dateTo: payload.dateTo,
    })
    yield put(actions.meterReadingsByDaySuccess(metersReadings.data))
  } catch (err) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logoutUser())
      }

      if (err.response.data) {
        yield put(actions.meterError(err.response.data))
      }
    }
  }
}

function* watchMeterReadingsByDay() {
  yield takeLatest(actions.Types.METER_READINGS_BY_DAY, meterReadingsByDay)
}

export default [
  fork(watchGetMetersRequest),
  fork(watchNewMeterReading),
  fork(watchNewCombinedMeterReading),
  fork(watchEnableManualReading),
  fork(watchMeterReadingsByDay),
]
